'use client';

import type { ChangeEventHandler } from 'react';

import { Input } from '@/components/ui/Input';

export interface ServiceSerialNumberInputProps {
  disabled?: boolean;
  error?: string | null;
  label: string;
  name?: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
  required?: boolean;
  value: string;
}

export function ServiceSerialNumberInput({
  disabled = false,
  error,
  label,
  name = 'serialNumber',
  onChange,
  required = true,
  value,
}: Readonly<ServiceSerialNumberInputProps>) {
  return (
    <Input
      autoComplete="off"
      disabled={disabled}
      error={error ?? undefined}
      fullWidth
      hasError={Boolean(error)}
      layout="floating"
      label={label}
      name={name}
      onChange={onChange}
      required={required}
      spellCheck={false}
      value={value}
    />
  );
}

ServiceSerialNumberInput.displayName = 'ServiceSerialNumberInput';
